import ModalAutoTSuccess from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoTSuccess/ModalAutoTSucces";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { wsPostAsignarPresenteLabo } from "_+_Portal/_-_Autocheckin/context/action/laboratorio";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { setTurnosRecepcionados } from "_+_Portal/_-_Autocheckin/context/action/turnosRecepcionados";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { mercadoPagoReset } from "_+_Portal/context/Actions/mercadoPago/mercadoPago";
import { PortalContext } from "_+_Portal/context/Provider";
import { useContext, useEffect, useState } from "react";
import { getLocalStorage } from "global/utils/safeJsonParse";

const CierreRecepcionLabo = ({ turnoActual, setTurnoActual }) => {
  const {
    pasoDispatch,
    puntoControlDispatch,
    turnosSeleccionadosState,
    turnosRecepcionadosDispatch,
  } = useContext(AutocheckContext);

  const { mercadoPagoDispatch } = useContext(PortalContext);

  const [loading, setLoading] = useState(true);
  const listaTurnos = turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const actual = listaTurnos[turnoActual];
  const turnosLenAll = listaTurnos.length;

  const config = getLocalStorage("config", {});
  let sectorTurno = config?.sectorTurno;

  const finzalizarRecepcion = () => {
    setLoading(false);
    let variosTurnos = listaTurnos.length > 1;
    if (variosTurnos) {
      setTurnosRecepcionados(actual)(turnosRecepcionadosDispatch);
      setPaso("TurnosRecepcionadosLabo")(pasoDispatch);
    } else {
      setPaso("TurnoRecepcionadoLabo")(pasoDispatch);
    }
  };

  const proximoTurno = () => {
    setTurnosRecepcionados(actual)(turnosRecepcionadosDispatch);
    setPaso("ResumenLabo")(pasoDispatch);
    setTurnoActual(turnoActual + 1);
  };

  const proximoPaso = (isCorrect) => {
    setLoading(false);
    if (!isCorrect) {
      const idTipoPuntoControl = 11;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    }
  };

  useEffect(() => {
    mercadoPagoReset()(mercadoPagoDispatch);
    wsPostAsignarPresenteLabo(actual?.idProtocolo, sectorTurno)(proximoPaso);
  }, []);

  return (
    <>
      {loading ? (
        <Loading
          dataLoading={loading}
          color="c-white"
          descripcion={"Cargando..."}
        />
      ) : (
        <ModalAutoTSuccess
          descripcion={`
      El ${actual?.especialidad} ${
            turnoActual + 1
          } de ${turnosLenAll}  ha sido recepcionado correctamente <br/>
    `}
          textBtn={
            turnoActual + 1 === turnosLenAll
              ? `Finalizar la recepción`
              : `Continuar Recepción`
          }
          onClick={
            turnoActual + 1 === turnosLenAll
              ? finzalizarRecepcion
              : proximoTurno
          }
        />
      )}
    </>
  );
};

export default CierreRecepcionLabo;
